module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-inner-d984cd31.svg";